import { useState, useEffect } from 'react';
import { getDoctorsManuallyAddedPatientsForDay, getMonthlyDoctorsManuallyAddedPatients } from '../../../utils/functions';
import MonthlyAddedPatients from './MonthlyAddedPatients';

export default function PatientAdditions({ doctor_id, doctor_name }) {
  const [patientAdditions, setPatientAdditions] = useState(null);
  const [openMonthlyPatientsModal, setOpenMonthlyPatientsModal] = useState(false);
  const [monthlyAddedPatients, setMonthlyAddedPatients] = useState(null);
  const [month, setMonth] = useState(-1);

  const updateMonthlyAddedPatients = async () => {
    setMonthlyAddedPatients(await getMonthlyDoctorsManuallyAddedPatients(doctor_id, month));
    setOpenMonthlyPatientsModal(true);
  }

  useEffect(() => {
    (async () => {
      setPatientAdditions(await getDoctorsManuallyAddedPatientsForDay(doctor_id));
    })()
  }, [])

  return (
    <>
      {patientAdditions !== null ? (
        <>
          <button onClick={updateMonthlyAddedPatients}>
            <p>{patientAdditions.totalPatients} | {patientAdditions.addedPatients}</p>
          </button>

          {openMonthlyPatientsModal && <MonthlyAddedPatients monthlyAddedPatients={monthlyAddedPatients} setMonthlyAddedPatients={setMonthlyAddedPatients} openMonthlyPatientsModal={openMonthlyPatientsModal} setOpenMonthlyPatientsModal={setOpenMonthlyPatientsModal} doctor_id={doctor_id} doctor_name={doctor_name} month={month} setMonth={setMonth} />}
        </>
      ) : (
        <span className="w-6 h-6 border-2 border-dashed rounded-full animate-spin border-ktx-purple mx-auto"></span>
      )
      }
    </>
  )
}